import firebase from "firebase/compat/app";
import { db } from "../firebase";

// Email y teléfono de cada usuario. users/{uid} lo puede leer cualquier
// usuario con sesión (hace falta para el mapa, la búsqueda, los perfiles),
// así que el contacto solo vive ahí si el usuario eligió mostrarlo en su
// perfil (Ajustes > Privacidad > "Mostrar mi email y teléfono"). Si no, va
// en users/{uid}/private/contact, que solo leen el dueño y el admin (ver
// match /private/{docId} y exposesHiddenContact en firestore.rules).
//
// Sin elegir nada, las empresas lo muestran (es su contacto comercial) y el
// resto no. Con "Perfil público" desactivado nunca se muestra.
export const showsContact = (userData) =>
  userData?.perfilPublico !== false &&
  (userData?.mostrarContacto ?? userData?.userType === "empresa");

const privateContactRef = (uid) => db.doc(`users/${uid}/private/contact`);

// Lee el contacto propio, esté donde esté.
export const loadOwnContact = async (uid, userData) => {
  let privateData = {};
  try {
    const snap = await privateContactRef(uid).get();
    privateData = snap.exists ? snap.data() : {};
  } catch (error) {
    console.error("No se pudo leer el contacto privado:", error);
  }
  return {
    email: privateData.email || userData?.email || "",
    phone: privateData.phone || userData?.phone || "",
  };
};

// Guarda email/teléfono (solo los campos que vengan) en el lugar que
// corresponde según `show`, y los saca del otro lugar.
export const saveContact = async (uid, contact, show) => {
  const fields = Object.fromEntries(
    Object.entries(contact).filter(([key, value]) => ["email", "phone"].includes(key) && value !== undefined)
  );
  if (Object.keys(fields).length === 0) return;
  const userRef = db.doc(`users/${uid}`);
  if (show) {
    await userRef.set(fields, { merge: true });
  } else {
    // Lo que todavía hubiera quedado en el doc público (cuentas de antes de
    // este ajuste) también pasa al privado.
    const userSnap = await userRef.get();
    const publicData = userSnap.exists ? userSnap.data() : {};
    const leftovers = Object.fromEntries(
      ["email", "phone"].filter((key) => publicData[key] && fields[key] === undefined).map((key) => [key, publicData[key]])
    );
    await privateContactRef(uid).set({ ...leftovers, ...fields }, { merge: true });
    const del = firebase.firestore.FieldValue.delete();
    await userRef.set({ email: del, phone: del }, { merge: true });
  }
};

// Cambio del ajuste "Mostrar mi email y teléfono": mueve los datos de un
// lugar al otro junto con el ajuste.
export const setContactVisibility = async (uid, show) => {
  const userRef = db.doc(`users/${uid}`);
  const userSnap = await userRef.get();
  const userData = userSnap.exists ? userSnap.data() : {};
  const contact = await loadOwnContact(uid, userData);
  const del = firebase.firestore.FieldValue.delete();
  if (show) {
    await userRef.set({ mostrarContacto: true, email: contact.email, phone: contact.phone }, { merge: true });
  } else {
    await privateContactRef(uid).set({ email: contact.email, phone: contact.phone }, { merge: true });
    await userRef.set({ mostrarContacto: false, email: del, phone: del }, { merge: true });
  }
};
